(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["CategorizedTagInput"] = factory(require("react"));
	else
		root["CategorizedTagInput"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _CategorizedTagInputJsx = __webpack_require__(5);
	
	var _CategorizedTagInputJsx2 = _interopRequireDefault(_CategorizedTagInputJsx);

	exports['default'] = _CategorizedTagInputJsx2['default'];
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(10);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(14)();
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var Tag = (0, _createReactClass2['default'])({
	  propTypes: {
	    selected: _propTypes2['default'].bool,
	    input: _propTypes2['default'].string.isRequired,
	    text: _propTypes2['default'].string.isRequired,
	    addable: _propTypes2['default'].bool,
	    deletable: _propTypes2['default'].bool,
	    onAdd: _propTypes2['default'].func,
	    onDelete: _propTypes2['default'].func,
	    style: _propTypes2['default'].object
	  },
	
	  // helps tests pass
	  getDefaultProps: function getDefaultProps() {
	    return {
	      text: ''
	    };
	  },
	
	  tagContent: function tagContent() {
	    var content = [];
	    var startIndex = this.props.text.trim().toLowerCase().indexOf(this.props.input.trim().toLowerCase());
	    var endIndex = startIndex + this.props.input.length;
	
	    if (startIndex > 0) {
	      content.push(_react2['default'].createElement(
	        'span',
	        { key: 1, className: 'cti__tag__content--regular' },
	        this.props.text.substring(0, startIndex)
	      ));
	    }
	
	    content.push(_react2['default'].createElement(
	      'span',
	      { key: 2, className: 'cti__tag__content--match' },
	      this.props.text.substring(startIndex, endIndex)
	    ));
	
	    if (endIndex < this.props.text.length) {
	      content.push(_react2['default'].createElement(
	        'span',
	        { key: 3, className: 'cti__tag__content--regular' },
	        this.props.text.substring(endIndex)
	      ));
	    }
	
	    return content;
	  },
	
	  onClick: function onClick(e) {
	    e.preventDefault();
	    if (this.props.addable) {
	      this.props.onAdd(e);
	    }
	  },
	
	  onDelete: function onDelete(e) {
	    // Prevents onClick event of the whole tag from being triggered
	    e.preventDefault();
	    e.stopPropagation();
	    this.props.onDelete(e);
	  },
	
	  getDeleteBtn: function getDeleteBtn() {
	    var style = this.props.style || {};
	    var deleteStyle = style['delete'] ? style['delete'] : {};
	
	    return _react2['default'].createElement('span', { className: 'cti__tag__delete', onClick: this.onDelete,
	      dangerouslySetInnerHTML: { __html: '&times;' },
	      style: deleteStyle });
	  },
	
	  render: function render() {
	    var deleteBtn = null;
	    if (this.props.deletable) {
	      deleteBtn = this.getDeleteBtn();
	    }
	    var cls = 'cti__tag' + (this.props.selected ? ' cti-selected' : '');
	
	    var style = this.props.style || {};
	
	    return _react2['default'].createElement(
	      'div',
	      { className: cls, onClick: this.onClick, style: style.base || {} },
	      _react2['default'].createElement(
	        'div',
	        { className: 'cti__tag__content', style: style.content || {} },
	        this.tagContent()
	      ),
	      deleteBtn
	    );
	  }
	});
	
	exports['default'] = Tag;
	module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isCategoryItemValid = isCategoryItemValid;
	exports.isCategoryValid = isCategoryValid;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputJsx = __webpack_require__(7);
	
	var _InputJsx2 = _interopRequireDefault(_InputJsx);
	
	var _PanelJsx = __webpack_require__(8);
	
	var _PanelJsx2 = _interopRequireDefault(_PanelJsx);
	
	var _keyboard = __webpack_require__(9);
	
	var key = _interopRequireWildcard(_keyboard);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function isCategoryItemValid(i) {
	  return typeof i === 'string' && i.trim().length > 0;
	}
	
	function isCategoryValid(c) {
	  return typeof c === 'object' && c.id && c.title && c.items && Array.isArray(c.items) && c.items.every(isCategoryItemValid) && (c.type || c.single);
	}
	
	var CategorizedTagInput = (0, _createReactClass2['default'])({
	  propTypes: {
	    addNew: _propTypes2['default'].bool,
	    categories: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired,
	    transformTag: _propTypes2['default'].func,
	    value: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
	    onBlur: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    placeholder: _propTypes2['default'].string,
	    getTagStyle: _propTypes2['default'].func,
	    getCreateNewText: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      value: '',
	      selection: {
	        item: 0,
	        category: 0
	      },
	      panelOpened: false,
	      categories: [],
	      addNew: this.props.addNew === undefined ? true : this.props.addNew
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onChange: function onChange(newTags) {
	        // do nothing
	      }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (!this.props.categories.every(isCategoryValid)) {
	      throw new Error('invalid categories source provided for react-categorized-tag-input');
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  filterCategories: function filterCategories(input) {
	    var _this = this;
	
	    var categories = this.props.categories.map(function (c) {
	      c = Object.assign({}, c, {
	        items: c.items.filter(_this.filterItems(input))
	      });
	      return c.items.length === 0 && (!_this.state.addNew || c.single) ? null : c;
	    }).filter(function (c) {
	      return c !== null;
	    });
	
	    var selection = this.state.selection;
	    if (this.state.selection.category >= categories.length) {
	      selection = {
	        category: 0,
	        item: 0
	      };
	    } else {
	      if (selection.item >= categories[selection.category].items.length) {
	        selection.item = 0;
	      }
	    }
	
	    this.setState({
	      categories: categories,
	      selection: selection
	    });
	  },
	
	  filterItems: function filterItems(input) {
	    return function (i) {
	      if (input.length === 1) {
	        return i.toLowerCase().trim() === input;
	      }
	      return i.toLowerCase().indexOf(input.trim().toLowerCase()) >= 0;
	    };
	  },
	
	  openPanel: function openPanel() {
	    this.setState({ panelOpened: true });
	  },
	
	  closePanel: function closePanel() {
	    var _this2 = this;
	
	    // Prevent the panel from hiding before the click action takes place
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.timeout = setTimeout(function () {
	      _this2.timeout = undefined;
	      _this2.setState({ panelOpened: false });
	    }, 150);
	  },
	
	  onValueChange: function onValueChange(e) {
	    var value = e.target.value;
	    this.setState({ value: value, panelOpened: value.trim().length > 0 || !isNaN(Number(value.trim())) });
	    this.filterCategories(value);
	  },
	
	  onTagDeleted: function onTagDeleted(i) {
	    var newTags = this.props.value.slice();
	    newTags.splice(i, 1);
	    this.props.onChange(newTags);
	  },
	
	  onAdd: function onAdd(newTag) {
	    var newTags = this.props.value.concat([newTag]);
	    this.setState({
	      value: '',
	      panelOpened: true
	    });
	
	    this.refs.input.focusInput();
	    this.props.onChange(newTags);
	  },
	
	  addSelectedTag: function addSelectedTag() {
	    if (!(this.state.panelOpened && this.state.value.length > 0)) {
	      return;
	    }
	
	    var category = this.state.categories[this.state.selection.category];
	    var title = category.items[this.state.selection.item];
	    this.onAdd({
	      category: category.id,
	      title: title || this.state.value
	    });
	  },
	
	  handleBackspace: function handleBackspace(e) {
	    if (this.state.value.trim().length === 0) {
	      e.preventDefault();
	      this.onTagDeleted(this.props.value.length - 1);
	    }
	  },
	
	  handleArrowLeft: function handleArrowLeft() {
	    var result = this.state.selection.item - 1;
	    this.setState({ selection: {
	        category: this.state.selection.category,
	        item: result >= 0 ? result : 0
	      } });
	  },
	
	  handleArrowUp: function handleArrowUp() {
	    var result = this.state.selection.category - 1;
	    this.setState({ selection: {
	        category: result >= 0 ? result : 0,
	        item: 0
	      } });
	  },
	
	  handleArrowRight: function handleArrowRight() {
	    var result = this.state.selection.item + 1;
	    var cat = this.state.categories[this.state.selection.category];
	    this.setState({ selection: {
	        category: this.state.selection.category,
	        item: result <= cat.items.length ? result : cat.items.length
	      } });
	  },
	
	  handleArrowDown: function handleArrowDown() {
	    var result = this.state.selection.category + 1;
	    var cats = this.state.categories;
	    this.setState({ selection: {
	        category: result < cats.length ? result : cats.length - 1,
	        item: 0
	      } });
	  },
	
	  onKeyDown: function onKeyDown(e) {
	    var result = undefined;
	    switch (e.keyCode) {
	      case key.TAB:
	      case key.ENTER:
	        if (!this.state.value) {
	          // enable normal tab/enter behavior
	          // (don't preventDefault)
	          break;
	        }
	      case key.COMMA:
	        e.preventDefault();
	        this.addSelectedTag();
	        break;
	      case key.BACKSPACE:
	        this.handleBackspace(e);
	        break;
	      case key.LEFT:
	        this.handleArrowLeft();
	        break;
	      case key.UP:
	        this.handleArrowUp();
	        break;
	      case key.RIGHT:
	        this.handleArrowRight();
	        break;
	      case key.DOWN:
	        this.handleArrowDown();
	        break;
	    }
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__root' },
	      _react2['default'].createElement(_InputJsx2['default'], { openPanel: this.openPanel, closePanel: this.closePanel,
	        onValueChange: this.onValueChange, onTagDeleted: this.onTagDeleted,
	        onKeyDown: this.onKeyDown, placeholder: this.props.placeholder, value: this.state.value,
	        getTagStyle: this.props.getTagStyle,
	        tags: this.props.value,
	        transformTag: this.props.transformTag,
	        onBlur: this.props.onBlur, ref: 'input' }),
	      this.state.panelOpened && this.state.value.length > 0 ? _react2['default'].createElement(_PanelJsx2['default'], { categories: this.state.categories,
	        selection: this.state.selection, onAdd: this.onAdd,
	        input: this.state.value,
	        getCreateNewText: this.props.getCreateNewText,
	        addNew: this.props.addNew === undefined ? true : this.props.addNew }) : ''
	    );
	  }
	});
	
	exports['default'] = CategorizedTagInput;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TagJsx = __webpack_require__(4);
	
	var _TagJsx2 = _interopRequireDefault(_TagJsx);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var getCreateNewText = function getCreateNewText(title, text) {
	  return 'Create new ' + title + ' "' + text + '"';
	};
	
	var Category = (0, _createReactClass2['default'])({
	  propTypes: {
	    items: _propTypes2['default'].array.isRequired,
	    category: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
	    title: _propTypes2['default'].string.isRequired,
	    selected: _propTypes2['default'].bool.isRequired,
	    selectedItem: _propTypes2['default'].number.isRequired,
	    input: _propTypes2['default'].string.isRequired,
	    addNew: _propTypes2['default'].bool,
	    type: _propTypes2['default'].string,
	    onAdd: _propTypes2['default'].func.isRequired,
	    single: _propTypes2['default'].bool,
	    getTagStyle: _propTypes2['default'].func,
	    getCreateNewText: _propTypes2['default'].func
	  },
	
	  onAdd: function onAdd(title) {
	    var _this = this;
	
	    return function () {
	      _this.props.onAdd({
	        category: _this.props.category,
	        title: title
	      });
	    };
	  },
	
	  onCreateNew: function onCreateNew(e) {
	    e.preventDefault();
	    this.onAdd(this.props.input)();
	  },
	
	  getTagStyle: function getTagStyle(item) {
	    return this.props.getTagStyle ? this.props.getTagStyle(item) : {};
	  },
	
	  itemToTag: function itemToTag(item, i) {
	    return _react2['default'].createElement(_TagJsx2['default'], { selected: this.isSelected(i),
	      input: this.props.input, text: item, addable: true, deletable: false,
	      onAdd: this.onAdd(item), key: item + '_' + i, style: this.getTagStyle(item) });
	  },
	
	  fullMatchInItems: function fullMatchInItems() {
	    for (var i = 0, len = this.props.items.length; i < len; i++) {
	      if (this.props.items[i] === this.props.input) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  getItems: function getItems() {
	    return {
	      items: this.props.items.map(this.itemToTag),
	      fullMatch: this.fullMatchInItems()
	    };
	  },
	
	  isSelected: function isSelected(i) {
	    return this.props.selected && (i === this.props.selectedItem || this.props.single);
	  },
	
	  getAddBtn: function getAddBtn(fullMatch, selected) {
	    var title = this.props.type || this.props.title;
	    var text = this.props.input;
	    var getText = this.props.getCreateNewText || getCreateNewText;
	    if (this.props.addNew && !fullMatch && !this.props.single) {
	      return [this.props.items.length > 0 ? _react2['default'].createElement(
	        'span',
	        { key: 'cat_or', className: 'cti__category__or' },
	        'or'
	      ) : null, _react2['default'].createElement(
	        'button',
	        {
	          key: 'add_btn',
	          className: 'cti__category__add-item' + (selected ? ' cti-selected' : ''),
	          onClick: this.onCreateNew
	        },
	        getText(title, text)
	      )];
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var _getItems = this.getItems();
	
	    var items = _getItems.items;
	    var fullMatch = _getItems.fullMatch;
	
	    var addBtn = this.getAddBtn(fullMatch, (items.length === 0 || this.props.selectedItem >= items.length) && this.props.selected);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__category' },
	      _react2['default'].createElement(
	        'h5',
	        { className: 'cti__category__title' },
	        this.props.title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'cti__category__tags' },
	        items,
	        addBtn
	      )
	    );
	  }
	});
	
	exports['default'] = Category;
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TagJsx = __webpack_require__(4);
	
	var _TagJsx2 = _interopRequireDefault(_TagJsx);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var Input = (0, _createReactClass2['default'])({
	  propTypes: {
	    openPanel: _propTypes2['default'].func.isRequired,
	    closePanel: _propTypes2['default'].func.isRequired,
	    onValueChange: _propTypes2['default'].func.isRequired,
	    onTagDeleted: _propTypes2['default'].func.isRequired,
	    onKeyDown: _propTypes2['default'].func.isRequired,
	    value: _propTypes2['default'].string.isRequired,
	    tags: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired,
	    placeholder: _propTypes2['default'].string,
	    onBlur: _propTypes2['default'].func,
	    getTagStyle: _propTypes2['default'].func,
	    transformTag: _propTypes2['default'].func
	  },
	
	  focusInput: function focusInput() {
	    this.refs.input.focus();
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      getTagStyle: function getTagStyle(tag) {
	        // empty style object by default
	        return {};
	      },
	      transformTag: function transformTag(tag) {
	        return tag.title;
	      }
	    };
	  },
	
	  getTags: function getTags() {
	    var _this = this;
	
	    return this.props.tags.map(function (tag, i) {
	      return _react2['default'].createElement(_TagJsx2['default'], { selected: false, input: '', text: _this.props.transformTag(tag), addable: false,
	        deletable: true, key: tag.title + '_' + i,
	        onDelete: function () {
	          return _this.props.onTagDeleted(i);
	        },
	        style: _this.props.getTagStyle(tag) });
	    });
	  },
	
	  onBlur: function onBlur(e) {
	    this.props.closePanel();
	    if (typeof this.props.onBlur === 'function') {
	      this.props.onBlur(e);
	    }
	  },
	
	  render: function render() {
	    var placeholder = this.props.placeholder || '';
	    var size = this.props.value.length === 0 ? placeholder.length : this.props.value.length;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__input', onClick: this.focusInput },
	      this.getTags(),
	      _react2['default'].createElement('input', { type: 'text', ref: 'input', value: this.props.value,
	        size: size + 2,
	        onFocus: this.props.openPanel, onBlur: this.onBlur,
	        onChange: this.props.onValueChange, onKeyDown: this.props.onKeyDown,
	        placeholder: placeholder, 'aria-label': placeholder,
	        className: 'cti__input__input' }),
	      _react2['default'].createElement('div', { className: 'cti__input__arrow' })
	    );
	  }
	});
	
	exports['default'] = Input;
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CategoryJsx = __webpack_require__(6);
	
	var _CategoryJsx2 = _interopRequireDefault(_CategoryJsx);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(2);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var Panel = (0, _createReactClass2['default'])({
	  propTypes: {
	    categories: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired,
	    selection: _propTypes2['default'].object.isRequired,
	    onAdd: _propTypes2['default'].func.isRequired,
	    input: _propTypes2['default'].string.isRequired,
	    addNew: _propTypes2['default'].bool,
	    getTagStyle: _propTypes2['default'].func,
	    getCreateNewText: _propTypes2['default'].func
	  },
	
	  getCategories: function getCategories() {
	    var _this = this;
	
	    return this.props.categories.map(function (c, i) {
	      return _react2['default'].createElement(_CategoryJsx2['default'], { key: c.id, items: c.items, category: c.id, title: c.title,
	        selected: _this.props.selection.category === i,
	        selectedItem: _this.props.selection.item,
	        input: _this.props.input, addNew: _this.props.addNew,
	        type: c.type, onAdd: _this.props.onAdd, single: c.single,
	        getTagStyle: _this.props.getTagStyle,
	        getCreateNewText: _this.props.getCreateNewText });
	    });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__panel' },
	      this.getCategories()
	    );
	  }
	});
	
	exports['default'] = Panel;
	module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAB = 9;
	exports.TAB = TAB;
	var ENTER = 13;
	exports.ENTER = ENTER;
	var BACKSPACE = 8;
	exports.BACKSPACE = BACKSPACE;
	var LEFT = 37;
	exports.LEFT = LEFT;
	var UP = 38;
	exports.UP = UP;
	var RIGHT = 39;
	exports.RIGHT = RIGHT;
	var DOWN = 40;
	exports.DOWN = DOWN;
	var COMMA = 188;
	exports.COMMA = COMMA;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(13);
	
	var emptyObject = __webpack_require__(11);
	var _invariant = __webpack_require__(12);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(15);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// categorized-tag-input.js